import { faqFirstStepsData } from 'src/libs/faq-lib/data/faq-first-steps.data'
import { faqGeneralData } from 'src/libs/faq-lib/data/faq-general.data'
import { faqGroupManagmentData } from 'src/libs/faq-lib/data/faq-group-management.data'
import { FAQData } from '../faq.model'

export const generateFaqData = (): FAQData => ({
    topics: [faqGeneralData, faqFirstStepsData, faqGroupManagmentData],
})
